/**
 * Target IDs for the `mandalorian` takeover.
 *
 * Single source of truth: imported only by `manifest.ts`. The runtime builder
 * expands manifest target groups into the legacy config maps.
 *
 * IDs are grouped by the declarative treatment they receive in `manifest.ts`.
 */

/** Simple home page IDs that receive mandalorian styling. */
export const shpIds = [
  '6cc4cd5a-9a89-49ca-a683-b5c741359b81', // dev lunch simple home page
  '55e96472-e610-4279-a2fa-646253da0982', // staging/prod SHP
  '2dff225f-1b19-43f0-8377-10e1af4cc9d7', // CA
];

/** Menu section IDs grouped by section config. */
export const menuSectionIds = {
  meals: [
    '8685f044-584e-42cd-abbf-34b7b6b9a5dc', // Mandalorian & Grogu Menu
    '5f3e07bb-fe83-47e0-be07-436045d66705', // CA - Mandalorian Menu
    'b021cd76-f960-4251-9530-b775978cc3fc', // Mandalorian & Grogu Menu - MW
    'a99d2e09-f674-40b6-b99e-42fa562cf2e1', // CA - Digital Exclusive Bundles - Mando
  ],
  kids: [
    'section_5603', // kids
    '87c69f30-1299-439c-9dfd-5d09c8fdb7d2', // Kings Jr Kids Meals - Mando
    'e16a5fec-06a5-4346-89f1-0ca2dc07b203', // CA - King Jr.® Kids Meals - Menu
  ],
};

/** PDP/cart item IDs grouped by item config (meal vs kids). */
export const pdpItemIds = {
  meal: [
    '896585b9-3cef-4380-bda7-2af9e686d1e1',
    '1c9e602d-4c2e-448b-9d92-ab464ec5e350',
    '12a7c772-c8e0-4888-a862-57f38294b0b6',
    '05e0f386-b263-42c7-ab8a-53cf5212ba06',
    'ad538c44-6b03-47ef-9523-b321c850871d',
    'c1417084-5f7c-48c1-b7cf-dc7e30dec936',
    '39e1b07c-48af-4d40-be24-db7e17d8869c',
    '799fab28-92f1-4fb6-ad7e-4f42c827456a',
    '71b10e46-fc54-48cb-9690-4cb8c72a74b7',
    '13a4e48f-6ce9-40da-94f1-08acb4a042c9',
    'cba0a5d3-5203-4d4f-b43e-04aee826a9f2',
    '8fab5cde-a779-49e9-94a5-70d587e5fdff',
    'a098d4a7-0ca0-4994-957d-3a345dbfa5a5',
    '3ff1b195-a95a-4b5a-a6df-629ab7fb23f5',
    '032e7179-b4a3-4c1e-830d-d7f3bf96bd5e',
    '922a1f87-9e61-4a0c-8ca4-117639f8a020',
    'bb8de58a-1c09-4879-9acb-91a4faafe638',
    'f1e76f2c-ce5d-414c-8e20-3806b38a1b1',
    'd9514b16-84d4-4e51-a079-4868ec4a8749',
    '51b82eee-5006-4304-9c82-9e1ce3fda975',
    '984914d4-ee4b-482f-98f1-17a1e7314073',
    '9bb95695-10f8-486d-9ba4-b1d1d59e429e',
    'e4bc5527-11e3-4a52-89a0-de31e185a2c1',
    '0253a803-386c-411b-9c78-d0e62d70d92f',
    '96309ed6-845d-4d6c-b200-b2cdf5031978',
    '665f4a52-4e19-42ec-a0f2-cdeeb7cf6f07',
    'c2b9b0b9-f4e5-411e-baee-f2837a77c4d5',
    'item_98808',
    '9aacaabb-764f-44a0-bae8-76d996ad1f1d',
    '505f2d7d-4494-4705-9469-fec60a2d6d5a',
    '03299d20-e40c-486b-8d0c-60d36c0ed066',
    '7c120f1a-92c5-46cb-a3cf-15ab4fd66032',
    'item_100926',
    'a75a4766-1d09-47e2-b39d-1e7e815ac8e6',
    '4d75f386-ae1a-409e-bec2-2ba36bc18365',
    '9607d1f7-1c96-4d28-8562-e118831d0477',
    'cbcb832a-8a97-4a24-9167-595c70c8bc45',
    '1a6f9a8c-932a-4fcf-aff3-c98dbc7cb1ef',
    'd0b59a70-d6df-4a3e-9df6-249f06b8a9c0',
    'f6bc61cd-d7f9-4660-9db2-d90c209662d4',
    '14b6a6d4-8682-444c-8246-63fafcb455d3',
    '22f174a3-666e-4e84-8deb-70fc495198cd',
    'item_98820',
    'item_98821',
    '645c9d94-1f43-4963-8f9d-3f6b1a64e120',
    'f553834b-d976-40e1-aa7d-0fd7b986e23c',
    '8ec40d59-a025-4215-b599-cb4cd5e18f78',
    'item_98822',
    '3936caa1-9e89-482e-80e2-bc8117ab4688',
    '664826eb-d3da-482f-947f-7a33f2df1306',
    '9af5c5d1-c7be-429a-8efe-2ba3f09a560f',
    'a1622827-91e8-4ac0-8949-5e0c20263f94',
    'f572014e-a22c-4fb9-8847-1d586b9caa2d',
    'cecbd2dd-d226-4b79-a214-b386c8eeba6f',
    'item_100928',
    'item_100929',
    '9b693346-1128-45a4-bca3-123207e7b605',
    '1de7a8b1-be31-4919-ada6-a33d2c92abba',
    'item_100931',
    '3629bdc8-3ee6-4dcd-b6f7-1b540a6433a1',
    'ddae925e-607b-4b07-9ff9-291c3588c77e',
    'item_101680',
    '8a39239e-7887-4005-ab57-1dd6fa3f0560',
    'item_101681',
    '32fd34d3-bce1-4e51-942c-c1c7e094a1cf',
    '54b12946-cdc0-457f-b22c-7a56ef468704',
    'a37e32f5-bf91-4efd-836b-20e20dfc2b70',
    'item_98823',
    'item_98824',
    'item_98825',
    'item_100934',
    'item_101679',
    'item_100074',
    'item_100075',
    'item_100937',
  ],
  kids: [
    'c7225019-9e47-43c4-8e97-8a6c4224a84a',
    'item_100073',
    'c06c5fc0-eb06-4bb4-8971-c81ca5793ecb',
    '71886320-6d80-410f-8743-ec5f548d9ea4',
    'c809e520-5e7a-4933-9fb0-b4044d5c559a',
    '1c18a56b-5b34-4100-8b76-85dc9c45e03c',
    'a6a71a64-2025-47ca-9e6f-150f6a7662f5',
    'a608a7fd-0e37-4dce-a86b-cc56c89d93d8',
    '8ca03cd7-e3cf-4e19-8521-7ed0c71b32ef',
    'item_103813',
    'item_103814',
    '55856076-94b7-4dfb-b00b-f83b535ea9e7',
    '2120e6c1-d3ee-4373-aff3-08162d355ecf',
    '25d3b74c-5a96-4511-ab41-882ee81a89ba',
    '49f6f383-9689-47a6-a4b1-2768c6772b7d',
    'd5e41231-090c-4653-8115-2703173138f4',
    '8f03d618-07f8-4b56-8089-f4f1085b6326',
    'd7f764ee-9c35-4579-9208-92583acbdcc2',
    'f54785b1-f361-4297-b7aa-534d7cfa368d',
    '6b5598bb-ac72-4c7e-81dd-1dc59bd8eacc',
  ],
};
